export default "__VITE_ASSET__oQzWKpb8__"